// AUTO-GENERATED by scripts/generate-version.js — do not edit by hand.
// Regenerated on every build from git metadata.

export const APP_VERSION       = "0.0.1";
export const BUILD_NUMBER      = "80";
export const BUILD_SHA         = "fe145db";
export const BUILD_DATE        = "2026-05-09T08:19:21.718Z";
export const VERSION_LABEL     = "v0.0.1 · build 80 · fe145db";
export const STORAGE_ENCRYPTED = true;
